import { palette } from '@centivo/react-components'
import React from 'react'

const IconFilter = ({
  color = palette.neutral['grey-icons'],
  showCircle = false,
}) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Results-Filter Copy 3@1.5x</title>

    <path
      d="M9.00192227,12.8261466 L1.23835232,3.64572512 C0.68869301,2.99575299 1.15069426,2 2.00192227,2 L22.0019223,2 C22.8531503,2 23.3151515,2.99575299 22.7654922,3.64572512 L15.0019223,12.8261466 L15.0019223,21 C15.0019223,21.743382 14.2196098,22.2268777 13.5547087,21.8944272 L9.55470867,19.8944272 C9.21592465,19.7250352 9.00192227,19.3787721 9.00192227,19 L9.00192227,12.8261466 Z M19.8466186,4 L4.15722594,4 L10.7654922,11.8142749 C10.9181565,11.9948003 11.0019223,12.223577 11.0019223,12.46 L11.0019223,18.381966 L13.0019223,19.381966 L13.0019223,12.46 C13.0019223,12.223577 13.0856881,11.9948003 13.2383523,11.8142749 L19.8466186,4 Z"
      id="path-1"
      fill={color}
    />

    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Style-Guide" transform="translate(-483.000000, -2703.000000)">
        <g
          id="Results-Filter-Copy-3"
          transform="translate(483.000000, 2704.000000)"
        >
          <g id="Group" transform="translate(0.000000, 1.000000)">
            <mask id="mask-2" fill="white">
              <use />
            </mask>
            <use id="Shape" fill="#7A7E81" fillRule="nonzero" />
          </g>
          {showCircle && (
            <circle
              id="Oval"
              stroke="#FFFFFF"
              fill="#EC008C"
              cx="21"
              cy="4"
              r="4"
            />
          )}
        </g>
      </g>
    </g>
  </svg>
)

export default IconFilter
